import React from "react";
import { useTranslation } from "react-i18next";

import { timestampColumn } from "../../ui/utils/columns";

import ImportStatusLabel from "../components/ImportStatus/ImportStatusLabel";

export default function useImportsTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "status",
			Header: t("status", "Status"),
			collapsing: true,
			Cell: ({ row }) => {
				return <ImportStatusLabel importt={row} />;
			},
		},
		{
			id: "source",
			collapsing: true,
			Header: t("source", "Source"),
		},
		{
			id: "title",
			Header: t("title", "Title"),
		},
		timestampColumn({ id: "created", Header: t("timestamp", "Timestamp") }),
	];
}
